import styled from '@emotion/styled'
import livePlayer from './LivePlayer.themes'
import getThemeConfig from '../../providers/config/themeConfig'

const {
  videoPlatform: {
    featuredVideoOverlay: { overlayMarginTop },
  },
} = getThemeConfig()

export const BrightCoveContainer = styled('div')({
  width: '100%',
  height: '100%',

  '.video-js, .brightcove-react-player-loader': {
    width: '100%',
    height: '100%',
  },

  '.vjs-modal-dialog .vjs-modal-dialog-content': {
    zIndex: 0,
  },
})

export const LiveContainer = styled('div')(
  ({ theme: { mediaQueries, slug, space } }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginTop: livePlayer[slug]
      ? `-${space[livePlayer[slug].topMargin]}`
      : 'initial',

    [mediaQueries.medium]: {
      marginTop: livePlayer[slug]
        ? `-${space[livePlayer[slug].topMarginDesktop]}`
        : 'initial',
    },
  })
)

export const LiveWrapper = styled('div')(
  ({ theme: { space, mediaQueries } }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: space.base,
    width: '100%',

    [mediaQueries.large]: {
      flexWrap: 'nowrap',
      overflow: 'hidden',
    },
  })
)

export const StyledPlayer = styled('div')(
  ({ theme: { mediaQueries }, splitSize, hasVotemo }) => {
    const splitWidthLarge = hasVotemo ? '65%' : '75%'
    const splitWidthXLarge = hasVotemo ? '70%' : '75%'

    return {
      marginTop: '0 !important',
      position: 'relative',
      minHeight: '30rem',
      minWidth: '100%',

      [mediaQueries.large]: {
        minHeight: splitSize ? '48rem' : '59rem',
        minWidth: splitSize ? splitWidthLarge : '100%',
        // TODO during animation there is a small gap appearing which it would be great if we can remove it
        transition: 'all 1s',
      },

      [mediaQueries.xlarge]: {
        minWidth: splitSize ? splitWidthXLarge : '100%',
      },
    }
  }
)

export const InteractionTool = styled('div')(
  ({ theme: { mediaQueries }, hasVotemo }) => ({
    position: 'relative',
    minHeight: hasVotemo ? '48rem' : '42rem',
    minWidth: '100%',

    [mediaQueries.medium]: {
      minHeight: '36rem',
    },

    [mediaQueries.large]: {
      minWidth: hasVotemo ? '35%' : '25%',
    },

    [mediaQueries.xlarge]: {
      minWidth: hasVotemo ? '30%' : '25%',
    },
  })
)

export const Overlay = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(4, 4, 4, 0.84)',
  zIndex: '1',
  display: 'flex',
  flexDirection: 'column-reverse',
  justifyContent: 'flex-end',
})

export const VideoOverlay = styled(Overlay)(
  ({ theme: { space, mediaQueries } }) => ({
    h1: {
      color: 'white',
      paddingLeft: space.large,
      marginBottom: space.medium,
      lineHeight: 1,
      fontSize: '3rem',

      [mediaQueries.large]: {
        paddingLeft: '9rem',
        marginTop: space.xxxlarge,
        marginBottom: space.large,
        fontSize: '6.2rem',
      },
    },
    h2: {
      color: 'white',
      paddingLeft: space.large,
      paddingRight: space.large,
      marginBottom: space.medium,
      lineHeight: 1,

      [mediaQueries.large]: {
        paddingLeft: '9rem',
        marginTop: overlayMarginTop,
        marginBottom: 0,
      },
      '&::before': {
        content: '""',
      },
    },
    h4: {
      color: 'white',
      paddingLeft: space.large,
      paddingRight: space.large,
      marginBottom: space.medium,
      lineHeight: 1,

      [mediaQueries.large]: {
        paddingLeft: '9rem',
        marginTop: space.medium,
        marginBottom: space.large,
      },
      '&::before': {
        content: '""',
      },
    },
    a: {
      margin: `${space.base} ${space.large} ${space.large}`,

      [mediaQueries.large]: {
        marginLeft: '9rem',
      },
    },
    img: {
      width: '10rem',
      marginLeft: space.large,
      marginBottom: space.large,

      [mediaQueries.large]: {
        width: '15rem',
        marginLeft: '9rem',
        marginBottom: '12rem',
      },
    },
  })
)

export const InteractionOverlay = styled(Overlay)({
  background: '#000',
  justifyContent: 'center',
  alignItems: 'center',
})

export const LiveTitleWrap = styled('iframe')(
  ({ theme: { mediaQueries } }) => ({
    height: '20rem',
    marginBottom: '1.5rem',
    width: '100%',

    [mediaQueries.small]: {
      height: '14rem',
    },

    [mediaQueries.medium]: {
      height: '10rem',
    },
  })
)

export const ToggleWrapper = styled('div')(
  ({ theme: { space, colors, mediaQueries } }) => ({
    display: 'none',
    [mediaQueries.large]: {
      display: 'flex',
      background: colors.offwhite,
      justifyContent: 'center',
      padding: space.small,
      width: '25%',
      alignItems: 'center',
    },
  })
)
